import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

const Container = styled.span`
    position: relative;
    display: flex;
    align-items: center;
    border-radius: 2px;
    padding: 6px 6px;
    ${({ theme }) => css`
        color: ${theme.colors['surface-white']};
        background-color: ${theme.colors['surface-grey-800']};
    `}
    &:focus {
        outline: none;
    }
`;

const Arrow = styled.div`
    position: absolute;
    top: -5px;
    left: ${(props) => `${props.length > 1 ? 23 : 13}px`};
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-radius: 0 1px;
    border-bottom: 5px solid var(--gray800);
`;

const TooltipWrapper = styled.div`
    @keyframes fadeIn {
        0% {
            opacity: 0;
        }

        100% {
            opacity: 1;
        }
    }

    z-index: 999;
    position: absolute;
    animation: fadeIn 100ms ease-in;
    transition: all 100ms linear;
    left: ${(props) => `${props.length > 1 ? props.left - 32 : props.left - 20}px`};
    top: ${(props) => `${props.top + 28}px`};
`;

const Char = styled.div`
    width: 24px;
    font-size: 16px;
    text-align: center;
    height: 24px;
    line-height: 20px;
`;

const Element = styled.div`
    display: flex;
    align-self: flex-start;
    border-radius: 2px;
    flex-direction: column;
    padding-top: 4px;
    padding-top: 4px;
    &:hover {
        background-color: var(--gray700);
        cursor: pointer;
    }
`;

const Index = styled.div`
    width: 24px;
    opacity: 50%;
    margin: 0;
    height: 20px;
    line-height: 16px;

    text-align: center;
    font-size: 14px;
`;

export const specialChars = {
    a: ['à', 'á', 'ª', 'â', 'ä', 'æ', 'ã', 'å', 'ā'],
    e: ['è', 'é', 'ê', 'ë', 'ę', 'ė', 'ē'],
    i: ['ì', 'í', 'î', 'ï', 'į', 'ī'],
    o: ['ò', 'ó', 'º', 'ô', 'ö', 'õ', 'œ', 'ø', 'ō'],
    u: ['ù', 'ú', 'û', 'ü', 'ū'],
    y: ['ÿ'],
    s: ['ß', 'ś', 'š'],
    c: ['ç', 'ć', 'č'],
    n: ['ñ'],
    '?': ['¿'],
    '!': ['¡'],
};

const SpecialCharTooltip = ({ char, handleClose, position }) => {
    const { left, top } = position;
    const content = specialChars[char.toLowerCase()];
    const uppercase = char === char.toUpperCase();

    return (
        <TooltipWrapper left={left} top={top} length={content.length}>
            <Arrow length={content.length} />
            <Container>
                {content.map((key, index) => (
                    <Element key={key} onClick={() => handleClose(uppercase ? key.toUpperCase() : key)}>
                        <Char>{(uppercase && key.toUpperCase()) || key}</Char>
                        <Index>{index < 9 ? index + 1 : 0}</Index>
                    </Element>
                ))}
            </Container>
        </TooltipWrapper>
    );
};

SpecialCharTooltip.propTypes = {
    char: PropTypes.string.isRequired,
    handleClose: PropTypes.func,
    position: PropTypes.object.isRequired,
};

export default SpecialCharTooltip;
